import { atomWithStorage } from "jotai/utils";

export const SELECTED_LORA_STORAGE_KEY = "gen-ad-chat-selected-lora";
export const selectedLoraIdAtom = atomWithStorage<string>(SELECTED_LORA_STORAGE_KEY, "");
